<template>
  <section class="section auth-section">
    <div class="box auth-card">

      <!-- Logo -->
      <div class="has-text-centered mb-5">
        <img src="/static/logo-wide.png" class="logo" alt="Logo">
      </div>

      <!-- Progress -->
      <div class="reset-progress mb-5">
        <div class="progress-line"></div>

        <div class="step step-complete">
          <span class="step-circle">✓</span>
          <span class="step-label">Request</span>
        </div>

        <div class="step step-complete">
          <span class="step-circle">2</span>
          <span class="step-label">Retrieve</span>
        </div>
      </div>

      <!-- Title -->
      <h2 class="title is-4 has-text-centered mb-4">
        We have received your password reset request
      </h2>

      <!-- Description -->
      <p class="has-text-centered mb-5">
        If the email address you provided is registered to your account,
        we will send password reset instructions to that email.
        Please check your inbox to continue.
      </p>

      <!-- Help Section -->
      <div class="info-section">

        <h4 class="info-title">
          Didn’t receive the email?
        </h4>

        <ul class="info-list">
          <li>Check your spam or junk folder</li>
          <li>Ensure the email address you entered is correct</li>
          <li>Wait a few minutes and try again</li>
          <li>Make sure your mailbox is not full</li>
        </ul>

        <p class="info-footer">
          Need more help?
          <a href="mailto:support@quickadmit.com" class="support-link">
            Contact support
          </a>
        </p>

      </div>

      <!-- Button -->
      <b-button
        expanded
        type="is-primary"
        size="is-medium"
        class="mt-5"
        tag="router-link"
        :to="{ name: 'Login' }"
      >
        Return to Sign In
      </b-button>

    </div>
  </section>
</template>

<script>
export default {
  name: "PasswordResetRequestSent"
};
</script>

<style scoped>

.auth-card{
  max-width:700px;
  margin:auto;
  padding:2.5rem;
  border-radius:14px;
}

.logo{
  max-height:60px;
}

/* Progress */

.reset-progress{
  position:relative;
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.progress-line{
  position:absolute;
  top:12px;
  left:15%;
  right:15%;
  height:2px;
  background:#e5e7eb;
}

.step{
  text-align:center;
  z-index:2;
}

.step-circle{
  display:inline-flex;
  justify-content:center;
  align-items:center;
  width:26px;
  height:26px;
  border-radius:50%;
  font-size:0.8rem;
}

.step-complete .step-circle{
  background:#48c774;
  color:white;
}


.step-label{
  display:block;
  margin-top:4px;
  font-size:0.75rem;
  color:#6b7280;
}

/* Info */

.info-section{
  background:#f9fafb;
  padding:1rem;
  border-radius:10px;
  font-size:0.9rem;
  color:#6b7280;
}

.info-title{
  font-weight:600;
  margin-bottom:0.75rem;
  color:#374151;
}

.info-list{
  padding-left:1.2rem;
  margin-bottom:1rem;
}

.info-list li{
  margin-bottom:0.5rem;
}

.support-link{
  color:#7957d5;
  text-decoration:none;
}

.support-link:hover{
  text-decoration:underline;
}

</style>